import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import { useEffect, useMemo, useState, useRef } from "preact/hooks"
import { nativePopularFilters } from "../../config"

import FilterList from "./FilterList"

export default function DesktopPopularFilters({ filters }) {
    const { facets } = useFacets();
    const [ activeDropdown, setActiveDropdown ] = useState(null);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setActiveDropdown(null);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const handleDropdownChange = (id) => {
        setActiveDropdown(id !== activeDropdown ? id : null)
    }
    
    return (
        <div class="hidden lg:inline-flex max-w-[60vw]">
            <form
                class="pl-xs border-l border-t-ui-lines-2"
                onSubmit={e => e.preventDefault()}
            >
                <div class="flex flex-wrap gap-xs text-t-foreground bg-t-background" ref={containerRef}>
                    {nativePopularFilters.map(facetName => {
                        const matchingFacet = facets.find(f => f.name.toLowerCase() === facetName.toLowerCase());
                        if(!matchingFacet) return null;
                        return (
                            <div class="ns-popular-dropdown relative js-filter border border-t-border-primary px-xs group/filter-dropdown cursor-pointer h-10 flex items-center bg-t-background open:bg-p-lightest">
                                <button 
                                    type="button" 
                                    class="ns-popular-toggle focus-inset flow-root h-full"
                                    id={`ns-filter-toggle-${matchingFacet.id}`} 
                                    aria-expanded={activeDropdown === matchingFacet.id}
                                    aria-controls={`ns-dropdown-panel-${matchingFacet.id}`}
                                    onClick={() => setActiveDropdown(activeDropdown === matchingFacet.id ? null : matchingFacet.id)}
                                >
                                    <div class="flex w-full h-full items-center justify-between">
                                        <span class="body-14 whitespace-nowrap">{matchingFacet.name}</span>
                                        <span class="ns-chevron-icon ml-sm flex items-center cursor-pointer text-t-brand-primary">
                                            <span class="transition-rotate block w-full h-full">
                                                <span class="block h-full w-full">
                                                    <svg aria-hidden="true" focusable="false" role="presentation" fill="none" class="icon icon-caret-down" id="icon-caret-down" viewBox="0 0 12 12">
                                                        <path stroke="currentColor" d="M11.5 3.5 6 8.313.5 3.5"></path>
                                                    </svg>
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                </button>
                                <div 
                                    class="ns-popular-dropdown-body py-xs px-4 shadow-custom bg-p-lightest min-w-60 z-10"
                                    id={`ns-dropdown-panel-${matchingFacet.id}`}
                                    aria-labelledby={`ns-filter-toggle-${matchingFacet.id}`}
                                    aria-hidden={activeDropdown !== matchingFacet.id}
                                    role="region"
                                >
                                    <FilterList facet={matchingFacet} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </form>
        </div>
    )
}
